 
import {UserRole} from './user-role.model';
import {User} from './user.model';
import {Principal} from './principal.service';

export class PrincipalUtils {
  //Main roles should not be combined as it could make some breaking bugs
  // Exception (SRS-47): ADVERTISER + FINANCE may be assigned together.
  // SALES_REPRESENTATIVE/CAMPAIGN_MANAGER/REV_OPS/DESIGNER are no longer real backend roles (see
  // user-role.model.ts) - kept here only so the mask-select.component.ts "preview as" buttons
  // (which still set these as principal.mask.role) keep working. USER/READONLY_USER/SUPER_ADMIN
  // are what the backend actually issues now and must be main roles for real accounts to log in.
  static MAIN_ROLES: string[] = [
    UserRole.ADMIN,
    UserRole.SUPER_ADMIN,
    UserRole.SALES_REPRESENTATIVE,
    UserRole.READ_ONLY_ADMIN,
    UserRole.USER,
    UserRole.READONLY_USER,
    UserRole.CAMPAIGN_MANAGER,
    UserRole.REV_OPS,
    UserRole.DESIGNER,
    UserRole.ADVERTISER,
    UserRole.FINANCE,
  ];
  //Additional roles that can be combined with Main Roles
  static ADDITIONAL_ROLES: string[] = [UserRole.PUBLISHER, UserRole.CONTENT_OWNER];
  static APP_MAP: Record<string, UserRole> = {
    'admin': UserRole.ADMIN,
    'publisher': UserRole.PUBLISHER,
    'co': UserRole.CONTENT_OWNER,
    'sr': UserRole.SALES_REPRESENTATIVE,
    'cm': UserRole.CAMPAIGN_MANAGER,
    'ro': UserRole.REV_OPS,
    'ds': UserRole.DESIGNER,
    'advertiser': UserRole.ADVERTISER,
    'finance': UserRole.FINANCE,
    'admin-readonly': UserRole.READ_ONLY_ADMIN,
  };

  static hasMoreThanOneMainRole(user: User) {
    const mainRoles = (user.roles ?? []).filter(r => this.MAIN_ROLES.includes(r));
    if (mainRoles.length <= 1) {
      return false;
    }
    // SRS-47: FINANCE is not subject to advertiser revenue masking even when also ADVERTISER.
    if (
      mainRoles.length === 2 &&
      mainRoles.includes(UserRole.ADVERTISER) &&
      mainRoles.includes(UserRole.FINANCE)
    ) {
      return false;
    }
    return true;
  }

  static isMasked(principal: Principal) {
    console.log('isMasked %s', JSON.stringify(principal.mask));
    const hasMaskRole = principal.mask.role;
    if (hasMaskRole) {
      switch (hasMaskRole) {
        case UserRole.ADMIN:
          return true;
        case UserRole.PUBLISHER:
          return !!principal.mask.publisherId;
        case UserRole.CONTENT_OWNER:
          return true;
        case UserRole.SALES_REPRESENTATIVE:
          return true;
        case UserRole.CAMPAIGN_MANAGER:
          return false;
        case UserRole.READ_ONLY_ADMIN:
          return true;
        case UserRole.SUPER_ADMIN:
          return true;
        case UserRole.USER:
          return true;
        case UserRole.READONLY_USER:
          return true;
        case UserRole.REV_OPS:
          return true;
        case UserRole.DESIGNER:
          return true;
        case UserRole.ADVERTISER:
          return true;
        case UserRole.FINANCE:
          return true;
      }
    }
    return false;
  }


  static filterMainRoles(roles: string[]) {
    return roles.filter(r => this.MAIN_ROLES.includes(r));
  }
}
